import {
  GetCollectionsCollectionAttributesAllV4Params,
  GetCollectionsCollectionAttributesAllV4Response,
  getGetCollectionsCollectionAttributesAllV4QueryOptions,
  useGetCollectionsCollectionAttributesAllV4,
} from '@/lib/reservoir/reservoir.generated';
import { ReservoirChain } from '@/utils/chains';
import { useMarketplaceChain } from './use-marketplace-chain';

const params: GetCollectionsCollectionAttributesAllV4Params = {};

export type CollectionAttribute = NonNullable<
  NonNullable<GetCollectionsCollectionAttributesAllV4Response['attributes']>[number]['values']
>[number];

const getCollectionAttributes = (
  chain: ReservoirChain,
  contractAddress: string,
  override?: GetCollectionsCollectionAttributesAllV4Params,
) => {
  return getGetCollectionsCollectionAttributesAllV4QueryOptions(
    contractAddress,
    { ...params, ...override },
    {
      query: {
        enabled: !!contractAddress,
        queryKey: [
          `/collections/${contractAddress}/attributes/all/v4`,
          chain.id,
          contractAddress,
          params,
          override,
        ],
      },
      request: {
        baseURL: chain.reservoirBaseUrl,
        headers: {
          'x-api-key': chain.reservoirApiKey,
        },
      },
    },
  );
};

const useCollectionAttributes = (
  contractAddress: string,
  override?: GetCollectionsCollectionAttributesAllV4Params,
) => {
  const chain = useMarketplaceChain();

  const request = useGetCollectionsCollectionAttributesAllV4(
    contractAddress,
    { ...params, ...override },
    {
      query: {
        enabled: !!contractAddress,
        queryKey: [
          `/collections/${contractAddress}/attributes/all/v4`,
          chain.id,
          contractAddress,
          params,
          override,
        ],
      },
      request: {
        baseURL: `${process.env.NEXT_PUBLIC_HOST_URL}${chain.proxyApi}`,
      },
    },
  );

  return request;
};

export { getCollectionAttributes, useCollectionAttributes };
